<template>
  <div>
    <NavigationBar titel="Veranstaltungen" isPreview :actions="actions">
      <template v-slot:tab-bar>
        <v-toolbar
          elevation="0"
          dense
          fixed
          :style="{
            'border-bottom-width': 'thin !important',
            'border-color': $vuetify.theme.dark
              ? 'rgb(255,255,255,0.12)'
              : 'rgb(0,0,0,0.12)',
            'border-bottom-style': 'solid !important',
          }"
        >
          <date-range-selector-menu
            v-model="dateRangeSelectorMenu"
            title="Zeitraum"
            btnText="Zeitraum auswählen"
            btnIcon="mdi-calendar"
          ></date-range-selector-menu>

          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="ml-2"
            @click="pageInFullscreen ? exitFullscreen() : enterFullScreen()"
            ><v-icon left small>{{
              pageInFullscreen ? "mdi-fullscreen" : "mdi-fullscreen-exit"
            }}</v-icon
            >{{
              pageInFullscreen ? "Vollbild verlassen" : "In Vollbild öffnen"
            }}</v-btn
          >
        </v-toolbar>
      </template>
    </NavigationBar>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-card>
                <v-card-title>XX.XX.2023 bis XX.XX.2023</v-card-title>
                <v-card-subtitle
                  >Angezeigte Daten und Diagramme beziehen sich nur auf den
                  ausgewählten Zeitraum.</v-card-subtitle
                >
              </v-card>
            </v-col>
            <v-col cols="12"
              ><statistics-multi-card
                title="Veranstaltungen nach Status"
                :subtitle="'Insgesamt ' + count.allEvents + ' im Zeitraum'"
                :data="statisticsData"
              ></statistics-multi-card
            ></v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="6">
              <statistics-chart-card
                title="Veranstaltungen nach Art"
                width="100%"
                type="pie"
                :options="typeOptions"
                :series="typeSeries"
                cardHeight="400px"
              ></statistics-chart-card>
            </v-col>
            <v-col cols="6"
              ><statistics-chart-card
                title="Status nach Wochentag"
                width="100%"
                type="bar"
                :options="options"
                :series="series"
                cardHeight="400px"
              ></statistics-chart-card
            ></v-col>
            <v-col cols="6">
              <statistics-chart-card
                title="Veranstaltungen nach Wochentag"
                width="100%"
                type="bar"
                :options="options"
                :series="typeWeekdaySeries"
                cardHeight="400px"
              ></statistics-chart-card>
            </v-col>
            <v-col cols="6"
              ><statistics-chart-card
                title="Status nach Wochentag"
                width="100%"
                type="bar"
                :options="options"
                :series="series"
                cardHeight="400px"
              ></statistics-chart-card
            ></v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import { db1 } from "@/firebase";
import {
  collection,
  query,
  where,
  getDocs,
  getCountFromServer,
} from "firebase/firestore";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import StatisticsMultiCard from "@/components/statistics/StatisticsMultiCard.vue";
import StatisticsChartCard from "@/components/statistics/StatisticsChartCard.vue";
import DateRangeSelectorMenu from "@/components/_system/helpers/DateRangeSelectorMenu.vue";
export default {
  name: "stats-events",
  components: {
    NavigationBar,
    StatisticsMultiCard,
    StatisticsChartCard,
    DateRangeSelectorMenu,
  },
  data() {
    return {
      count: {
        finishedEvents: 0,
        plannedEvents: 0,
        postponedEvents: 0,
        canceledEvents: 0,
        allEvents: 0,
      },
      pageInFullscreen: false,
      dateRangeSelectorMenu: false,

      baseChartOptions: {
        fontFamily: "Roboto",
        tooltip: {
          theme: this.$vuetify.theme.dark ? "dark" : "light",
          style: {
            fontFamily: "Roboto",
          },
        },
      },
      typeOptions: {
        chart: {
          id: "vuechart-events-type",
        },
      },
      typeSeries: [],
      typeWeekdaySeries: [],
      options: {
        chart: {
          id: "vuechart-example",
          stacked: true, // Enable stacking
          type: "bar", // Ensure the chart type is set to bar
        },
        xaxis: {
          categories: [
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag",
            "Sonntag",
          ],
        },
        yaxis: {
          title: {
            text: "Anzahl der Veranstaltungen",
          },
        },
        tooltip: {
          shared: true, // Show combined tooltip for stacked data
          intersect: false,
        },
        legend: {
          position: "top",
        },
        plotOptions: {
          bar: {
            horizontal: false, // Ensure vertical bars
          },
        },
        ...this.baseChartOptions,
      },
      series: [],
      eventTypes: [],
    };
  },
  computed: {
    statisticsData() {
      return [
        {
          title: "Abgeschlossen",
          icon: "mdi-calendar-check",
          color: "green",
          value: this.count.finishedEvents,
          percentage: this.calculatePercentage(
            this.count.finishedEvents,
            this.count.allEvents
          ),
        },
        {
          title: "Geplant",
          icon: "mdi-calendar-clock",
          color: "blue",
          value: this.count.plannedEvents,
          percentage: this.calculatePercentage(
            this.count.plannedEvents,
            this.count.allEvents
          ),
        },
        {
          title: "Verschoben",
          icon: "mdi-calendar-alert",
          color: "orange",
          value: this.count.postponedEvents,
          percentage: this.calculatePercentage(
            this.count.postponedEvents,
            this.count.allEvents
          ),
        },
        {
          title: "Abgesagt",
          icon: "mdi-calendar-remove",
          color: "red",
          value: this.count.canceledEvents,
          percentage: this.calculatePercentage(
            this.count.canceledEvents,
            this.count.allEvents
          ),
        },
      ];
    },
  },
  mounted() {
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
  },

  async created() {
    this.getEventStatsStatusByWeekday();
    await this.getEventTypes(); // Fetch event types first, and only then continue
    await this.getEventStatsType();
    await this.getEventStatsTypeByWeekday();
  },
  methods: {
    async getEventTypes() {
      try {
        const eventTypesQuery = collection(
          db1,
          "organizations",
          this.$route.params.organizationId,
          "eventTypes"
        );

        const eventTypesSnapshot = await getDocs(eventTypesQuery);
        let eventTypes = [];

        eventTypesSnapshot.forEach((doc) => {
          eventTypes.push({ id: doc.id, ...doc.data() });
        });

        // Sort event types by sortKey
        eventTypes = eventTypes.sort((a, b) => a.sortKey - b.sortKey);

        this.eventTypes = eventTypes;
      } catch (error) {
        console.error("Error fetching event types:", error);
      }
    },
    async getEventStatsStatusByWeekday() {
      const weekdays = [1, 2, 3, 4, 5, 6, 7]; // ISO 8601 weekdays: 1 (Monday) to 7 (Sunday)
      const statuses = ["finished", "planned", "postponed", "canceled"];
      const countsByWeekday = {
        finished: Array(7).fill(0),
        planned: Array(7).fill(0),
        postponed: Array(7).fill(0),
        canceled: Array(7).fill(0),
      };

      for (const status of statuses) {
        for (const weekday of weekdays) {
          const queryByStatusAndWeekday = query(
            collection(
              db1,
              "organizations",
              this.$route.params.organizationId,
              "events"
            ),
            where("status", "==", status),
            where("duration.start.weekday", "==", weekday)
          );

          const snapshot = await getCountFromServer(queryByStatusAndWeekday);
          countsByWeekday[status][weekday - 1] = snapshot.data().count; // Map weekday (1-7) to array index (0-6)
        }
      }

      // Update the series data for the stacked column chart
      this.series = [
        {
          name: "Geplant",
          color: "#2196F3",
          data: countsByWeekday.planned,
        },
        {
          name: "Abgeschlossen",
          color: "#4CAF50",
          data: countsByWeekday.finished,
        },
        {
          name: "Abgesagt",
          color: "#F44336",
          data: countsByWeekday.canceled,
        },
        {
          name: "Verschoben",
          color: "#FF9800",
          data: countsByWeekday.postponed,
        },
      ];
    },
    async getEventStatsType() {
      try {
        const eventTypes = this.eventTypes;

        // Initialize typeSeries data
        const typeCounts = Array(eventTypes.length).fill(0);

        // Get the count of events for each type
        for (let i = 0; i < eventTypes.length; i++) {
          const eventType = eventTypes[i];
          const eventsQuery = query(
            collection(
              db1,
              "organizations",
              this.$route.params.organizationId,
              "events"
            ),
            where("type.id", "==", eventType.id)
          );

          const snapshot = await getCountFromServer(eventsQuery);
          typeCounts[i] = snapshot.data().count;
        }

        // Update the typeSeries data for the chart
        this.typeSeries = typeCounts;
        this.typeOptions = {
          labels: eventTypes.map((type) => type.title),
          colors: eventTypes.map((type) => type.color || "#000000"), // Default to black if no color is provided
        };
      } catch (error) {
        console.error("Error fetching event stats by type:", error);
      }
    },
    async getEventStatsTypeByWeekday() {
      try {
        const weekdays = [1, 2, 3, 4, 5, 6, 7]; // ISO 8601 weekdays: 1 (Monday) to 7 (Sunday)
        const eventTypes = this.eventTypes;

        // Initialize counts for each event type by weekday
        const countsByTypeAndWeekday = eventTypes.map((eventType) => ({
          name: eventType.title,
          color: eventType.color || "#000000", // Default to black if no color is provided
          data: Array(7).fill(0), // Initialize with 0 for each weekday
        }));

        // Fetch counts for each event type and weekday
        for (let i = 0; i < eventTypes.length; i++) {
          const eventType = eventTypes[i];
          for (const weekday of weekdays) {
            const queryByTypeAndWeekday = query(
              collection(
                db1,
                "organizations",
                this.$route.params.organizationId,
                "events"
              ),
              where("type.id", "==", eventType.id),
              where("duration.start.weekday", "==", weekday)
            );

            const snapshot = await getCountFromServer(queryByTypeAndWeekday);
            countsByTypeAndWeekday[i].data[weekday - 1] = snapshot.data().count; // Map weekday (1-7) to array index (0-6)
          }
        }

        // Update the series data for the stacked column chart
        this.typeWeekdaySeries = countsByTypeAndWeekday;
      } catch (error) {
        console.error("Error fetching event stats by type and weekday:", error);
      }
    },
    calculatePercentage(value, total) {
      if (total === 0) {
        return 0;
      }
      const percentage = (value / total) * 100;
      return percentage.toFixed(2);
    },
    handleFullscreenChange() {
      if (document.fullscreenElement) {
        this.pageInFullscreen = true;
      } else {
        this.pageInFullscreen = false;
      }
    },
    enterFullScreen() {
      this.pageInFullscreen = true;
      const element = document.querySelector("body");
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen(); // Firefox
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(); // Safari
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen(); // IE/Edge
      }
    },
    exitFullscreen() {
      this.pageInFullscreen = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
  },
};
</script>
